// extracted by css-extract-rspack-plugin
module.exports =  {"icon":"CreateAmendment__icon___xxqOc"};